export default [
    {
        path: 'marcas',
        name: 'empresa.marcas',
        component: () => import('@/views/empresa/marcas/MarcasEmpresaHome.vue'),
    }
]

